import * as R from "ramda";
import React, {Component} from "react";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import withFormGroup from "../../../modules/commons/withFormGroup";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleToggleButton from "../../../modules/SimpleToggleButton";
import Api from "../../../Services/Api";
import {ACTIVITY_TYPE, Status} from "../../common/Constants";
import {mapToObjectDDL} from "../../common/mapper";

class MasterKasModifying extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cabangOptions: [],
        };
    }

    async componentDidMount() {
        const response = await Api.create(
            "NAGAMAS_MASTER_DATA"
        ).findAllMasterCabang();
        if (response.ok) {
            this.setState((prevValue) => ({
                ...prevValue,
                cabangOptions: response.data.data.map((value) =>
                    mapToObjectDDL(value.namaDealer, value.kodeCabang)
                ),
            }));
        }
    }

    handleSubmit = () => {
        if (this.props.validate()) {
            this.props.onSubmit(this.props.controls);
        }
    };

    render() {
        const {errors} = this.props;
        return (
            <SimpleModal
                title="Form Data Kas"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                        <SimpleInput
                            id="input_text_kode_kas"
                            name="kodeKas"
                            label="Kode Kas"
                            readOnly={R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE)}
                            mandatory
                            errorMessage={errors.kodeKas}
                            value={this.props.controls.kodeKas.value}
                            onChange={({target}) =>
                                this.props.setValue(target.name, target.value)
                            }
                        />
                        <SimpleDDL
                            id="select_options_nama_cabang"
                            name="kodeCabang"
                            label="Nama Cabang"
                            box="search"
                            isClearable
                            mandatory
                            options={this.state.cabangOptions}
                            errorMessage={errors.kodeCabang}
                            value={this.props.controls.kodeCabang.value}
                            onChange={(value, {name}) => this.props.setValue(name, value)}
                        />
                        <SimpleInput
                            id="input_text_nama_kas"
                            name="name"
                            label="Nama Kas"
                            mandatory
                            errorMessage={errors.name}
                            value={this.props.controls.name.value}
                            onChange={({target}) =>
                                this.props.setValue(target.name, target.value)
                            }
                        />
                        <SimpleToggleButton
                            label="Status"
                            value={R.equals(
                                this.props.controls.status.value,
                                Status.ACTIVE
                            )}
                            onToggle={(value) =>
                                this.props.setValue(
                                    "status",
                                    !value ? Status.ACTIVE : Status.INACTIVE
                                )
                            }
                        />
                        <div style={{textAlign: "center"}}>
                            <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
                        </div>
                    </ModalContainer>
                }
            />
        );
    }
}

export default withFormGroup(MasterKasModifying);
